import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";
import axios from "axios";

import Header from "./components/Header";

import homeImg1 from "../images/sponser-speaker-img_1.png";
import homeImg2 from "../images/sponser-speaker-img_2.png";

const SponsorSpeaker_Home = () => {
    const [orderId, setOrderId] = useState();

    const [eventId, setEventId] = useState([]);
    const [posId, setPosId] = useState();

    const [loaded, setLoaded] = useState(false);

    const [selectedIam, setSelectedIam] = useState("");

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    const { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // Remove addressBody from localStorage on first page load
        localStorage.removeItem("selectedIam");
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotionsSponsorSpeaker", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        requestResources();

        // so it wont get called on first load
        if (loaded) {
            startOrder(posId, eventId);
        }
    }, [language]); //everytime language is changed

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID
            setPosId(res.data.posId);
            setEventId(res.data.eventId);

            startOrder(res.data.posId, res.data.eventId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const onSubmit = async () => {
        try {
            await addAddressToBasket();
        } catch (error) {
            // Optionally set a generic error message
        }
    };

    const addAddressToBasket = async () => {
        // Store SelectedIam in localStorage for later use
        localStorage.setItem("SponsorSpeakerOption1", selectedIam);
        // Navigate to the next step
        navigate(`/${language}/sponsor-speaker/tickets`);
    };

    // Computed variable for Next button disabled state (AGB3 not considered)
    const isNextDisabled =
        selectedIam === "";

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">

                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                        <span className="text-subtitle d-block">{resources?.SpeakerSponsorHomeTitle}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <span>{resources?._Iam}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-6">
                        {/* I am - radiobutton group */}

                        <img className="img-fluid" src={homeImg2} alt="home" />

                        {/* Professional */}
                        <label className="d-flex align-items-center mt-4" style={{ cursor: "pointer" }}>
                            <input
                                type="radio"
                                name="iam"
                                value={resources?.SponsorSpeakerIamValue1}
                                checked={selectedIam === resources?.SponsorSpeakerIamValue1}
                                onChange={() => setSelectedIam(resources?.SponsorSpeakerIamValue1)}
                                className="d-none"
                            />
                            <i className={`bi bi${selectedIam === resources?.SponsorSpeakerIamValue1 ? "-check" : ""}-circle me-2`}></i>
                            <span>{resources?.SponsorSpeakerIamValue1}</span>
                        </label>
                    </div>

                    <div className="col-6">
                        <img className="img-fluid" src={homeImg1} alt="home" />

                        {/* Private */}
                        <label className="d-flex align-items-center mt-4" style={{ cursor: "pointer" }}>
                            <input
                                type="radio"
                                name="iam"
                                value={resources?.SponsorSpeakerIamValue2}
                                checked={selectedIam === resources?.SponsorSpeakerIamValue2}
                                onChange={() => setSelectedIam(resources?.SponsorSpeakerIamValue2)}
                                className="d-none"
                            />
                            <i className={`bi bi${selectedIam === resources?.SponsorSpeakerIamValue2 ? "-check" : ""}-circle me-2`}></i>
                            <span>{resources?.SponsorSpeakerIamValue2}</span>
                        </label>
                    </div>
                </div>
            </div>

            {/* next button*/}
            <div className="container wrapper-small">
                <div className="row mt-5">

                    <div className="col-md-12 text-end">
                        <button className="btn button-custom" onClick={() => onSubmit()} disabled={isNextDisabled}>{resources?.Next}</button>
                    </div>
                </div>

                <p className="mt-4">
                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                </p>
            </div>
        </div>
    )
}

export default SponsorSpeaker_Home